import React from 'react';

export const AnalyzeAssetsSolarHeader = () => {
  return <div> Analyze Assets Solar Header </div>;
};

AnalyzeAssetsSolarHeader.propTypes = {};

AnalyzeAssetsSolarHeader.defaultProps = {};
